























































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import Number from "@/shared/filters/Number";
import { InspectionItem } from "@/model/InspectionSeibi";
import { Utils } from "@/service/util";
import { MESSAGE } from "@/model/Message";
import { Getter, Action } from "vuex-class";
import requestService from "@/service/requestService";
import { InspectButtonValue } from "@/model/InspectButtonValue";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import { DO_TENKEN } from "@/model/DoTenken";
import { UserService } from "@/service/UserService";
import { SocketControllers } from "@/service/SocketControllers";
import InputNumber from "@/components/common/input/InputNumber.vue";
import { INSPECT_VALUE_VIEW_TYPE, INSPECT_VALUE_LINE, INSPECT_VALUE_NEXTAGE } from "@/model/InspectValueViewType";
import HibiValue from "@/components/HibiValue.vue";
import { INSPECT_TYPE } from "@/model/InspectType";
import { SeibiItem } from "@/model/InspectionSeibi";
import { InspectService } from "@/service/inspectService";
import ExtendsImageDialog from "@/components/ExtendsImageDialog.vue";
import { ExtendsImageService } from "@/service/ExtendsImageService";
import { ExtendsImageInspectVO } from "@/model/ExtendsImage";

@Component({
  components: {
    ConfirmDialog,
    InputNumber,
    HibiValue,
    ExtendsImageDialog
  },
  filters: {
    Number
  }
})
export default class WorkDetail extends Vue {
  readonly INSPECT_VALUE_VIEW_TYPE = INSPECT_VALUE_VIEW_TYPE;
  reqService: requestService;
  sktControll: SocketControllers;
  id: any;
  doTenken: number = 0;
  workName: string = "";
  workListDisplay: boolean = false;
  inspectCommentBody: string = "";
  inspectCommentTitle: string = "";
  meyasuTime: number = 0;
  savePercent: number = 50;
  warningPercent: number = 35;
  riskPercent: number = 15;
  inspect: InspectionItem = {} as InspectionItem;
  imgList: string[] = [];
  imgListWidth: number = 0;
  imgWidth: number = 0;
  imgIndex: number = 0;
  disabledPrevImg: boolean = true;
  disabledNextImg: boolean = true;
  imgTransitionCss: string = "";

  isError: boolean = false;
  errorMsg: string = "";
  showDialog: boolean = false;
  showDialogKouchin: boolean = false;
  isSave: boolean = false;
  timerNotify: any = null;
  isEditBuihin: boolean = false;

  listSeibi: any = [];
  nextageFilter: number = 0; // 0:全部、1:法定のみ 2:法定以外
  workDetailBasicMode: boolean = true;
  isExitConnectSocket: boolean = false;

  public utils: Utils = new Utils();

  @Getter("uketsukeCd", { namespace: "ReservationDetail" })
  uketsukeCd: string;
  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;
  @Action("setSeibiData", { namespace: "InspectSeibiAK3" })
  setSeibiAK3Data: any;

  @Action("updateInspectDoTenken", { namespace: "InspectSeibi" })
  updateDotenken: any;

  @Action("updateDoTenkenFromSocket", { namespace: "InspectSeibi" })
  updateDoTenkenFromSocket: any;

  @Getter("doTenkenById", { namespace: "InspectSeibi" })
  doTenkenById!: (inspectType: number, inspectId: number) => number;

  @Action("setListInspectId", { namespace: "InspectSeibi" })
  setListInspectId: any;

    @Getter("hasData", { namespace: "InspectSeibi" })
  hasData: boolean;

    @Getter("seibiLoading", { namespace: "UserDataState" })
  isLoading: boolean;

  @Getter("getSeibiData", { namespace: "InspectSeibi" })
  seibiData: SeibiItem[][];

  @Getter("listInspectByType", { namespace: "InspectSeibi" })
  listInspect!: (inspectType: number) => any;

  @Getter("nextInspectId", { namespace: "InspectSeibi" })
  nextInspectId!: (id: number) => number;

  @Getter("prevInspectId", { namespace: "InspectSeibi" })
  prevInspectId!: (id: number) => number;

  @Getter("listInspectAll", { namespace: "InspectSeibiAK3" })
  listInspectAk3!: any[];

  /** 2023-10-19 invoice [START] */
  @Getter("isExcludingTax", { namespace: "FunctionSetting" })
  isExcludingTax: any;

  /** 2023-10-19 invoice [END] */
  @Getter("isNextageCustom", { namespace: "FunctionSetting" })
  isNextageCustom: any;
  @Getter("isCanExtendsImage", { namespace: "FunctionSetting" })
  isCanExtendsImage: any;


  @Getter("freeOfChargeLabelFull", { namespace: "FunctionSetting" })
  freeOfChargeLabel: any;

  inspectService: InspectService = new InspectService();

  CROSS: number = InspectButtonValue.CROSS;
  TRIANGLE: number = InspectButtonValue.TRIANGLE;
  CIRCLE: number = InspectButtonValue.CIRCLE;

  tempBuhinList: any = [];
  isSaving: boolean = false;
  originalBuhins: any = null;

  seibiList: any = [];
  isSavingEditPrice: boolean = false; // for check save kouchin
  carSelection: any = {};
  isHasValue = false;
  loading: boolean = true;
  mode = 0;
  prevId = -1;
  nextId = -1;
  currentIndex = -1;
  loadingData = true;
  loadingText: string = MESSAGE.Loading;

  extendsImageService: ExtendsImageService = new ExtendsImageService();
  extendsImageInspect: ExtendsImageInspectVO | null = null;
  showExtendsImageDialog: boolean = false;

  /*
   * 初期化関数
   * ( createdやmountedで1回だけ実行される必要があるが
   *   特定のパラメータが足りない時は実行順序を前後させる必要がある処理 )
   */
  @Watch("uketsukeCd")
  connectSocket() {
    // 必要な値が未セット、または初期化済みなら何もしない
    if (!this.uketsukeCd || this.isExitConnectSocket) { return; }
    this.isExitConnectSocket = true;

    this.sktControll = new SocketControllers(this);
    this.sktControll.socketEntry("inspectSubscription",this.onInspectcompleted); // catchSocket:ソケット仮04
    this.sktControll.socketEntry("inspectSeibiSubscribe",this.onSeibiItemcompleted); // catchSocket:ソケット仮06
    // catchSocket:13するしない後日編集
    this.sktControll.socketEntry("doTenkenSubscribe",this.onInspectionDotenken);
    this.sktControll.connectSocket();
  }

  created() {
    if (this.$route.query.inspect) {
      this.mode = 1; // getInspectSeibiAK3_2引数
      this.id = +this.$route.query.inspect;
      if (this.$route.query.index) {
        this.currentIndex = +this.$route.query.index;
      }
    } else {
      this.mode = 2;
      this.id = +this.$route.query.seibi;
      window.console.error('WorkDetail.vue $route.query.inspectが空', this.id, this.inspect && this.inspect.sknInspectId);
    }
  }

  mounted() {
    this.reqService = new requestService();
    this.connectSocket();
    this.getSeibi();// 一覧。画面右の金額表示、前次の表示に必要
    this.$nextTick(() => {
      if (this.$route.name) {
        this.setInspectType(this.$route.name);
      }
      this.initData();
      this.$nextTick(() => {
        if (!this.workDetailBasicMode) {
          this.setListSeibi(); // 現車57、おすすめ整備 もしくは 保安、安心整備のリスト
        }
      });
    }); 
  }

  @Watch("$route")
  onRouteChange(to: any, from: any) {
    this.getSeibi();
    this.$nextTick(() => {
      this.setInspectType(to.name);
      this.initData();

      this.$nextTick(() => {
        if (!this.workDetailBasicMode) {
          this.setListSeibi(); // 現車57、おすすめ整備 もしくは 保安、安心整備のリスト
        }
      });
    });
  }

  setInspectType(routeName: string) {
    if (routeName == 'workdetail') {
      // 通常の呼び出し
      this.workDetailBasicMode = true;
    } else {
      this.workDetailBasicMode = false;
      
      if (routeName == "legal56workdetail") {
        // 現車57
        this.nextageFilter = 0;
      } else if (routeName == "legal56Nex1workdetail") {
        // 保安基準
        this.nextageFilter = 1;
      } else if (routeName == "legal56Nex2workdetail") {
        // 安心
        console.log("routeName",routeName);
        this.nextageFilter = 2;
      }
      
    }
    this.$nextTick(() => {
      this.setPrevNextId();
    });
  }

  setPrevNextId() {
    if (this.workDetailBasicMode) {
      if (this.currentIndex == -1) {
        this.$set(this, "prevId", this.prevInspectId(this.id));
        this.$set(this, "nextId", this.nextInspectId(this.id));
      } else if (this.inspect.inspectResult) {
        const result = this.inspect.inspectResult - 1;
        let prevId = -1;
        let nextId = -1;
        const list = this.listInspectAk3[result].map((row: any, index: number) => {
          return row.sknInspectId;
        });// 〇×△毎のリスト(通常動作)
        
        if (this.currentIndex > 0) {
          prevId = list[this.currentIndex - 1];
        }
        if (this.currentIndex < list.length -1) {
          nextId = list[this.currentIndex + 1];
        }
        this.$set(this, "prevId", prevId);
        this.$set(this, "nextId", nextId);
      }  
    } else {

      // ネクステージ版：車検結果以外でも前へ次へを表示
      if (this.currentIndex != -1 && this.isNextageCustom ) {
        let prevId = -1;
        let nextId = -1;
        // 現車57、おすすめ整備 もしくは 保安、安心整備のリスト。一度ロードしたものを利用する
        const list = this.listSeibi; 

        if (this.currentIndex > 0) {
          prevId = list[this.currentIndex - 1];
        }
        if (this.currentIndex < list.length -1) {
          nextId = list[this.currentIndex + 1];
        }
        this.$set(this, "prevId", prevId);
        this.$set(this, "nextId", nextId);
      } else {
        return; // 前へ次へを表示は不要
      }
    }
  }

  setListSeibi() {
    
    this.reqService.checkJizenSort(this.uketsukeExtendsId).then((res: any) => {
      let isJizenSort = "true" === res.toString();
      let listSeibiCache: any;
      let listSeibi: any;
      if (isJizenSort) {
        let seibi = JSON.parse(JSON.stringify(this.seibiData));
        if (seibi && seibi.length > 0) {
          let index = 0;
          listSeibiCache = seibi[index];
        }
      } else {
        listSeibiCache = this.listInspect(INSPECT_TYPE.LEGAL56);
      }

      // 前へ次へ表示するIDリストの表示位置を調べるかどうかのフラグ(画面遷移やF5実行時)
      let currentIndexSearch = false;
      if ( this.currentIndex == -1 ) { currentIndexSearch = true; }

      if (listSeibiCache && this.nextageFilter != 0) {
        // ネクステージでは保安基準とそれ以外で別機能にする必要がある
        // 両方この機能で表示しているので表示モードに合わせて適切な方の内容をリストに残す
        if ( this.nextageFilter==1 ) {
          this.listSeibi = listSeibiCache.filter((item: any) => 
            // 保安基準で×のもの
            item.isHoanKijun == 1 && item.inspectResult == 2
          ).map((row: any, index: number) => {
            if ( currentIndexSearch ) {
              if ( this.mode == 1 && row.sknInspectId == this.id ) {
                this.currentIndex = index;
              } else if ( this.mode == 2 && row.sknInspectSeibiId == this.id ) {
                // this.$route.query.seibi;している時の一致パターン(多分)
                this.currentIndex = index;
              }
            }
            return row.sknInspectId;
          });
        } else {
          this.listSeibi = listSeibiCache.filter((item: any) => 
            // 保安基準以外か△ののもの
            item.isHoanKijun == 0 || item.inspectResult != 2
          ).map((row: any, index: number) => {
            if ( currentIndexSearch ) {
              if ( this.mode == 1 && row.sknInspectId == this.id ) {
                this.currentIndex = index;
              } else if ( this.mode == 2 && row.sknInspectSeibiId == this.id ) {
                // this.$route.query.seibi;している時の一致パターン(多分)
                this.currentIndex = index;
              }
            }
            return row.sknInspectId;
          });
        }
      } else {
        this.listSeibi = listSeibiCache.map((row: any, index: number) => {
          if ( currentIndexSearch ) {
            if ( this.mode == 1 && row.sknInspectId == this.id ) {
              this.currentIndex = index;
            } else if ( this.mode == 2 && row.sknInspectSeibiId == this.id ) {
              // this.$route.query.seibi;している時の一致パターン(多分)
              this.currentIndex = index;
            }
          }
          return row.sknInspectId;
        });
      }
      this.setPrevNextId();
    });
  }

  initData(isReinit = false) {
    this.loadingData = true;
    this.reqService
      .getInspectSeibiAK3_2(this.uketsukeExtendsId, this.id, 0, this.mode)
      .then(
        (data: any) => {
          this.loadingData = false;
          this.inspect = data as InspectionItem;
          // ネクステージ版で前へ次へしたときにリストを更新する場合。
          // ロード時間はかかるが別セッションで整備リストを増減したときに追従できる
          if (!this.workDetailBasicMode && this.isNextageCustom ) {
            this.setListSeibi(); // 現車57、おすすめ整備 もしくは 保安、安心整備のリスト
          } else {
            this.setPrevNextId();
          }
          this.getHibi();
          this.getExtendsImageInspect();

          let doTenken = this.doTenkenById(
            this.inspect.sknInspectType,
            this.inspect.sknInspectId
          );
          if (doTenken && this.inspect.doTenken == 0) {
            this.inspect.doTenken = doTenken;
          } else if (this.inspect.doTenken == 0) {
            if (this.inspect.inspectResult == InspectButtonValue.CROSS) {
              this.inspect.doTenken = DO_TENKEN.suru;
            } else if (
              this.inspect.inspectResult == InspectButtonValue.CIRCLE
            ) {
              this.inspect.doTenken = DO_TENKEN.shinai;
            }
          }
          // this.inspect.seibiList[0]seibiNm
          const useInspectCommentTitle =
            this.inspect.inspectCommentTitle != "" &&
            this.inspect.inspectValueViewType != INSPECT_VALUE_VIEW_TYPE.GROUND_CLR; // 地上最低高の動きに互換性を持たせるための条件
          if (useInspectCommentTitle) {
            this.workName = this.inspect.inspectCommentTitle;
            this.workListDisplay = false;
          } else {
            // 車検名の格納場所が異なる場合
            if (this.inspect.sknInspectDescriptionNm!="") {
              this.workName = this.inspect.sknInspectDescriptionNm;
            } else {
              this.workName = "";
            }
            // 以後、登録作業の数で挙動分岐
            if ( this.inspect.seibiList.length == 0 ) {
              this.workListDisplay = false;
              if ( this.workName == "" ) { this.workName = ""; } // 代替作業名
            } else if ( this.inspect.seibiList.length == 1 ) {
              this.workListDisplay = true;
              if ( this.workName == "" ) { this.workName = this.inspect.seibiList[0].seibiNm; } // 代替作業名
            } else {
              this.workListDisplay = true;
              if ( this.workName == "" ) { this.workName = "複数作業"; } // 代替作業名
            }
          }
          
          this.inspectCommentBody = this.inspect.inspectCommentSankou;
          this.inspectCommentTitle = this.inspect.inspectCommentMeyasu;
          this.meyasuTime = this.inspect.koukanMeyasuTime;
          this.doTenken = this.inspect.doTenken;
          this.imgList = this.inspect.img;
          let imgWrap = document.getElementById("div-1");
          if (this.inspect.img.length > 0 && imgWrap) {
            this.checkDisableBtnImg();
            let w = imgWrap.clientWidth;
            this.imgWidth = w;
            this.imgListWidth = this.inspect.img.length * w;
          }
          if (isReinit) {
            this.$forceUpdate();
          }
        },
        (error: any) => {
          this.loadingData = false;
          this.isError = true;
          if (error.status == 204) {
            this.errorMsg = MESSAGE.NoData;
            (this.$refs.errorDialog as any).onOpen();
          } else {
            this.errorMsg = MESSAGE.SystemError;
            (this.$refs.errorDialog as any).onOpen();
          }
        }
      )
      .catch(err => {
        // console.log(err);
        this.loadingData = false;
        this.isError = true;
        this.errorMsg = MESSAGE.SystemError;
        (this.$refs.errorDialog as any).onOpen();
      });
  }

  getSeibi() {
    // 部品詳細でF5したときに画面右の各金額を再度ロードする処理
    if (!this.hasData && !this.isLoading) {
      const userService = new UserService();
      userService.getAllData();
    }
  }

  repleceNewline(str: string) {
    return str.replace(/\n/g, "<br/>");
  }

  onRadioClick(event: any, val: number) {
    if (!this.isError) {
      if (val && val != this.doTenken) {
        this.doTenken = +val;
      }
      this.changeDoTenken();
    }
    event.preventDefault();
  }

  changeDoTenken() {
    if (this.inspect) {
      this.isSave = true;
      this.inspect.doTenken = this.doTenken;
      this.updateDotenken(this.inspect);
      this.reqService
        .updateDoTenken(
          this.uketsukeExtendsId,
          this.doTenken,
          this.inspect.sknInspectId
        )
        .then(res => {
          const userService = new UserService();
          userService.autoSaveAk7(); // sendSocket:ソケット仮34
        });
    }
  }

  isNoEdit() {
    let isdisabled = false;
    if (this.inspect && this.inspect.buhinList && this.inspect.buhinList.length == 0) { isdisabled = true; }
    if ( this.isNextageCustom && this.inspect.isDiscount===1) { isdisabled = true; }
    return isdisabled;
  }

  onInspectcompleted(frame: any) {
    const body = this.utils.getWSData(frame);
    const seibi = { ...body };
    delete seibi.sknWorkProgressState;
    delete seibi.sknWorkProgressStateNm;
    this.setSeibiAK3Data(seibi);
    if (
      seibi.sknInspectDescriptionId == this.inspect.sknInspectDescriptionId
    ) {
      let newInspect = { ...this.inspect, ...seibi };
      this.$set(this, "inspect", newInspect);
      this.getHibi();
      this.notify();
    } else {
      this.notify();
    }
  }
  onInspectionDotenken(frame: any) {
    if (this.isSave) {
      this.isSave = false;
    } else {
      const body = this.utils.getWSData(frame);
      if (body.sknUketsukeInspectId == this.inspect.sknInspectId) {
        this.inspect.doTenken = body.doTenken;
        this.doTenken = body.doTenken;
        this.updateDoTenkenFromSocket(body);
        this.$forceUpdate();
        this.notify();
      }
    }
  }

  notify() {
    if (this.timerNotify) {
      clearTimeout(this.timerNotify);
      this.timerNotify = null;
    }
    this.timerNotify = setTimeout(() => {
      this.$notify.info({
        title: "Info",
        message: MESSAGE.UpdatedInspections
      });
    }, 500);
  }

  onSeibiItemcompleted() {
    this.setListInspectId(this.listInspect(1));
    this.setPrevNextId();
  }

  get buhinZn() {
    if (this.inspect) {
      return this.inspect.buhinZn;
    }
    return 0;
  }

  get buhinZk() {
    if (this.inspect) {
      return this.inspect.buhinZk;
    }
    return 0;
  }

  get kouchinZn() {
    if (this.inspect) {
      return this.inspect.kouchinZn;
    }
    return 0;
  }

  get kouchinZk() {
    if (this.inspect) {
      return this.inspect.kouchinZk;
    }
    return 0;
  }

  get total() {
    let kouchinZk = this.kouchinZk;
    let kouchinZn = this.kouchinZn;
    if (kouchinZn < 0) {
      kouchinZk = 0;
      kouchinZn = 0;
    }
    return this.isExcludingTax? (kouchinZn + this.buhinZn) : (kouchinZk + this.buhinZk);
  }

  getValue(index: number) {
    if (
      this.inspect.inspectValue &&
      this.inspect.inspectValue.length > 0 &&
      (this.inspect.inspectValue[index] ||
       this.inspect.inspectValueViewType == INSPECT_VALUE_VIEW_TYPE.SIDE_SLIP)
    ) {
      return this.inspect.inspectValue[index].toFixed(1);
    }
    return "-";
  }

  getValueYm() {
    if (this.inspect.inspectValueStr && this.inspect.inspectValueStr[0]) {
      const val = this.inspect.inspectValueStr[0];
      if (val != null) {
        const val1 = parseInt(val.substring(0, 4), 10);
        const val2 = parseInt(val.substring(4, 6), 10);
        return `${val1}年${val2}月`;
      }
    } else if (this.inspect.inspectValue && this.inspect.inspectValue[0] === 1) {
      return 'なし　LED';
    }
    return "-";
  }

  cssBoxValue(index: number) {
    let inspectResult = this.getInspectResult(index);
    if (inspectResult == InspectButtonValue.CROSS) {
      return "risk";
    } else if (inspectResult == InspectButtonValue.CIRCLE) {
      return "save";
    } else if (inspectResult == InspectButtonValue.TRIANGLE) {
      return "warning";
    }
  }

  getInspectResult(index: number) {
    let value = this.inspect.inspectValue[index];
    let checkLine: any; // 判定基準値
    if ( this.isNextageCustom ) {
      checkLine = INSPECT_VALUE_NEXTAGE;
    } else {
      checkLine = INSPECT_VALUE_LINE;
    }
    if (this.inspect.inspectValueViewType === INSPECT_VALUE_VIEW_TYPE.TIRE) {
      return this.inspectService.inspectResultCheckValue( value, checkLine.TIRE );
    } else if (this.inspect.inspectValueViewType === INSPECT_VALUE_VIEW_TYPE.BRAKE ) {
      return this.inspectService.inspectResultCheckValue( value, checkLine.BRAKE );
    } else if (this.inspect.inspectValueViewType === INSPECT_VALUE_VIEW_TYPE.BRAKE_REAR) {
      return this.inspectService.inspectResultCheckValue( value, checkLine.BRAKE_REAR );
    }
    return InspectButtonValue.CIRCLE;
  }

  get getTextInspectResult() {
    if (this.inspect.inspectResult == InspectButtonValue.TRIANGLE) {
      return "予防整備が必要です";
    } else if (this.inspect.inspectResult == InspectButtonValue.CROSS) {
      return "作業が必要です";
    }
    return "";
  }

  getHeightBox() {
    if (typeof this.inspect.inspectValueViewType == "number") {
      if (this.inspect.inspectValueViewType == 0) {
        return "h172";
      } else if (this.inspect.inspectValueViewType == INSPECT_VALUE_VIEW_TYPE.TIRE) {
        return "h67";
      }
      return "";
    }
    return "h172";
  }

  openBuhinList() {
    if (this.inspect.buhinList.length > 0) {
      this.showDialog = true;
      this.tempBuhinList = this.utils.deepCopy(this.inspect.buhinList);
    }
  }

  onClose() {
    this.showDialog = false;
  }

  onNextImg() {
    this.imgIndex++;
    this.checkDisableBtnImg();
    this.imgTransitionCss = `transform: translateX(-${this.imgIndex *
      this.imgWidth}px)`;
  }

  onPrevImg() {
    this.imgIndex--;
    this.checkDisableBtnImg();
    if (this.imgIndex == 0) {
      this.imgTransitionCss = "";
    } else {
      this.imgTransitionCss = `transform: translateX(-${this.imgIndex *
        this.imgWidth}px)`;
    }
  }

  checkDisableBtnImg() {
    if (this.imgIndex == 0) {
      this.disabledPrevImg = true;
    } else {
      this.disabledPrevImg = false;
    }
    if (this.imgList.length > 0 && this.imgIndex == this.imgList.length - 1) {
      this.disabledNextImg = true;
    } else {
      this.disabledNextImg = false;
    }
  }

  onImgError(index: number) {
    this.$set(this.imgList, index, "");
    if (this.imgList.filter(img => img != "").length <= 1) {
      this.$set(this, "disabledPrevImg", true);
      this.$set(this, "disabledNextImg", true);
    }
  }

  makeDisplayBuhinData(id: number) {
    let buhinText = "";
    let noBuhinText = "部品なし";
    if ( id == 0 ) { return noBuhinText; }
    this.inspect.buhinList.forEach((elm: any) => {
      if ( elm.inspectSeibiId == id || elm.manualSeibiId == id ) {
        if ( buhinText != "" ) { buhinText += " / "; }
        buhinText += elm.buhinNm;
      }
    });
    return buhinText != "" ? buhinText : noBuhinText ;
  }

  resetBuhinPrice() {
    let listBuhin: any = [];
    if (this.originalBuhins) {
      listBuhin = this.inspect.buhinList.filter((buhin: any, i: number) => {
        if ( this.isExcludingTax ) {
          return this.originalBuhins[i].buhinUnitPriceZn != buhin.buhinUnitPriceZn;
        } else {
          return this.originalBuhins[i].buhinUnitPriceZk != buhin.buhinUnitPriceZk;
        }
      });
    } else {
      listBuhin = this.inspect.buhinList;
    }
    if (!this.isSaving) {
      const buhins = listBuhin.map((e: any) => {
        return { id: e.id, type: e.type };
      });
      if (buhins.length > 0) {
        const data = { sknUketsukeExtendsId: this.uketsukeExtendsId, buhins };
        this.isSaving = true;
        this.reqService.resetBuhinPriceAk3_2(data).then(() => { // sendSocket:ソケット仮06
          this.isSaving = false;
          this.reGetData(true);
        });
      } else {
        this.isEditBuihin = false;
      }
    }
  }

  reGetData(isReset: boolean, isResetKouchin: boolean = false) {
    this.reqService
      .getInspectSeibiAK3_2(this.uketsukeExtendsId, this.id, 0, 1)
      .then((data: any) => {
        this.inspect = data as InspectionItem;
        if (isReset) {
          this.originalBuhins = this.utils.deepCopy(this.inspect.buhinList);
        }
        if (isResetKouchin) {
          this.seibiList = this.utils.deepCopy(this.inspect.seibiList);
          this.mapSeibiListForShow();
        }
        this.$forceUpdate();
      });
  }

  onCloseDialogBuhin() {
    if (this.isEditBuihin) {
      this.isEditBuihin = false;
      const buhins = this.inspect.buhinList
        .filter((buhin: any, i: number) => {
          return (
            this.tempBuhinList[i].buhinUnitPriceZn != buhin.buhinUnitPriceZn ||
            this.tempBuhinList[i].buhinUnitPriceZk != buhin.buhinUnitPriceZk ||
            this.tempBuhinList[i].buhinQuantity != buhin.buhinQuantity
            || this.tempBuhinList[i].isIgnore != buhin.isIgnore
          );
        })
        .map((e: any) => {
          const b = { ...e };
          if (b.buhinUnitPriceZn == null) {
            b.buhinUnitPriceZn = 0;
          }
          if (b.buhinUnitPriceZk == null) {
            b.buhinUnitPriceZk = 0;
          }
          delete b.buhinNm;
          delete b.isDiscount;
          delete b.checkIsIgnore;
          return b;
        });
      const data = {
        sknUketsukeExtendsId: this.uketsukeExtendsId,
        buhins
      };
      // sendSocket:02作業指示の編集（するしない後日および部品代） // sendSocket:ソケット仮06
      this.reqService.saveBuhinAk3_2(data).then((res: any) => {
        this.reGetData(false);
      }, err => {
        this.$notify.error({
          title: "エラー",
          message: this.utils.getHttpErrorMessage(err)
        });
      });
    }
  }

  getBuhinTotalPriceZn(buhin: any) {
    if ((buhin.buhinQuantity * 10) % 10 > 0) {
      return Math.round(buhin.buhinQuantity * buhin.buhinUnitPriceZn * 10) / 10;
    } else {
      return buhin.buhinQuantity * buhin.buhinUnitPriceZn;
    }
  }

  getBuhinTotalPriceZk(buhin: any) {
    if ((buhin.buhinQuantity * 10) % 10 > 0) {
      return Math.round(buhin.buhinQuantity * buhin.buhinUnitPriceZk * 10) / 10;
    } else {
      return buhin.buhinQuantity * buhin.buhinUnitPriceZk;
    }
  }

  onEditBuhin(buhin: any) {
    this.isEditBuihin = true;
    if ( this.isExcludingTax ) {
      buhin.buhinTotalPriceZn = this.getBuhinTotalPriceZn(buhin);
    } else {
      buhin.buhinTotalPriceZk = this.getBuhinTotalPriceZk(buhin);
    }
  }

  mapSeibiListForShow() {
    this.seibiList = this.seibiList.map((e: any) => {
      if (!e.isKouchinEdit) {
        e.kouchinEditZn = !e.kouchinZn ? 0 : e.kouchinZn;
        e.kouchinEditZk = !e.kouchinZk ? 0 : e.kouchinZk;
      }
      return e;
    });
  }

  openSeibiList() {
    this.showDialogKouchin = true;
    this.seibiList = this.utils.deepCopy(this.inspect.seibiList);
    this.mapSeibiListForShow();
  }

  resetKouchin() {
    if (!this.isSavingEditPrice) {
      let seibiList: any;
      if ( this.isExcludingTax ) {
        seibiList = this.seibiList.filter(
          (e: any) => e.kouchinEditZn != e.kouchinZn
        );
      } else {
        seibiList = this.seibiList.filter(
          (e: any) => e.kouchinEditZk != e.kouchinZk
        );
      }
      if (seibiList.length > 0) {
        this.isSavingEditPrice = true;
        const promise: any = seibiList.map(async (e: any) => {
          let obj = this.mapObjEditPrice(e, false);
          return await this.reqService.updatePrice(obj);
        });
        Promise.all(promise).then(() => {
          this.isSavingEditPrice = false;
          this.reGetData(false, true);
        });
      }
    }
  }

  mapObjEditPrice(seibi: any, isEdit: boolean = true) {
    let obj: any = {
      sknUketsukeExtendsId: this.uketsukeExtendsId,
      buhinEditTotalZk: null
    };
    if (isEdit) {
      if (seibi.kouchinEditZk == null) {
        seibi.kouchinEditZk = 0;
      }
      if (seibi.kouchinEditZn == null) {
        seibi.kouchinEditZn = 0;
      }
      obj.kouchinEditZn = seibi.kouchinEditZn;
      obj.kouchinEditZk = seibi.kouchinEditZk;
    } else {
      obj.kouchinEditZk = null;
      obj.kouchinEditZn = null;
    }
    if (seibi.type == 2) {
      obj.sknUketsukeInspectSeibiManualId = seibi.id;
    } else {
      obj.sknUketsukeInspectSeibiId = seibi.id;
    }
    return obj;
  }

  editKouchin(seibi: any) {
    const obj = this.mapObjEditPrice(seibi);
    this.reqService.updatePrice(obj).then((res: any) => { // sendSocket:ソケット仮01
      this.reGetData(false);
    }, err => {
      this.$notify.error({
        title: "エラー",
        message: this.utils.getHttpErrorMessage(err)
      });
    });
  }

  checkHasValue() {
    if (
      this.inspect.inspectValue &&
      this.inspect.inspectValue.length > 0&&
      this.inspect.inspectValue[0] != null
    ) {
      return true;
    }
    return false;
  }

  getHibi() {
    this.isHasValue = this.checkHasValue();

    if (this.inspect.inspectValueViewType === INSPECT_VALUE_VIEW_TYPE.TIRE) {
      this.loading = true;
      this.reqService
        .getCarSelection(this.uketsukeExtendsId)
        .then((res: any) => {
          if (res) {
            this.carSelection = res;
            this.loading = false;
            this.$forceUpdate();
          }
        });
    } else {
      this.loading = false;
    }
  }

  goPrev() {
    if (this.currentIndex > 0) {
      this.currentIndex --;
    }
    this.gotoDetail(this.prevId);
  }

  goNext() {
    if (this.currentIndex > -1) {
      this.currentIndex ++;
    }
    this.gotoDetail(this.nextId);
  }

  gotoDetail(id: number) {
    this.id = id;
    this.mode = 1;
    this.setPrevNextId();
    this.initData(true);
  }

  onChangeIsIgnore(buhin: any) {
    this.isEditBuihin = true;
    buhin.isIgnore = buhin.checkIsIgnore ? 0: 1;
    if ( this.isExcludingTax ) {
      buhin.buhinTotalPriceZn = this.getBuhinTotalPriceZn(buhin);
    } else {
      buhin.buhinTotalPriceZk = this.getBuhinTotalPriceZk(buhin);
    }
  }
  isNeedBuhin(buhin: any) {
    return buhin.isIgnore == 0;
  }

  @Watch("listInspectAk3")
  reInitData() {
    this.initData();
  }

  async getExtendsImageInspect() {
    if (!this.isCanExtendsImage) { return; }
    this.extendsImageInspect = await this.extendsImageService.getExtendsImageInspectByInspectId(this.id);
    this.extendsImageService.connectSocket(this.extendsImageSocketCallback);
  }
  extendsImageSocketCallback(updatedList: ExtendsImageInspectVO[]) {
    // この画面で開いている点検の画像が更新された場合のみ反映し、それ以外の点検の画像の更新は無視する（都度API実行で取得するため）
    if (this.extendsImageInspect 
    && updatedList[0].sknUketsukeInspectId === this.extendsImageInspect.sknUketsukeInspectId) {
      this.$message({
        message: MESSAGE.UpdatedImage,
        type: "info",
        duration: 700,
        customClass: "msg-center shadow",
        showClose: true
      });
      this.extendsImageInspect = updatedList[0];
    }
  }
  get hasImage(): boolean {
    return !!(
      this.isCanExtendsImage &&
      this.extendsImageInspect &&
      this.extendsImageInspect.imageList &&
      this.extendsImageInspect.imageList.length > 0
    );
  }
}
